import { Checkbox } from "elements/checkbox/Checkbox";
// @ts-ignore
import "./CheckboxFormElement.scss";
import { COLORS } from "models/colors";
import { bemElement } from "utils/bem-class-names";
import { IFormElement } from "../FormBuilder";

const baseClassName = "checkbox-form-element";
const bem = bemElement(baseClassName);

interface ICheckboxFormElementProps {
  element: IFormElement;
  checkTopAlign?: boolean;
}

export const CheckboxFormElement = ({
  element,
  checkTopAlign
}: ICheckboxFormElementProps): JSX.Element => {
  return (
    <div className={baseClassName}>
      <div className={`${bem("body")} ${checkTopAlign ? "items-start" : ""}`}>
        <Checkbox
          className={checkTopAlign ? "min-w-[40px] -ml-11px" : "-ml-11px"}
          id={element.name}
          color={
            element.props.errorMsg
              ? COLORS.ERROR
              : element.props.color || COLORS.PRIMARY
          }
          checked={element.props.checked || false}
          onChange={element.props.onChange || (() => {})}
          {...element.props}
        />
        <label className={bem("label")} htmlFor={element.name}>
          {element.props.JSXLabel || element.props.label}
        </label>
      </div>
      <div className={bem("error-container")}>
        {element.props.errorMsg && <span>{element.props.errorMsg}</span>}
      </div>
    </div>
  );
};
